import { useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';
import GridAtom from '@components/atom/grid/grid';
import DataTable from 'react-data-table-component';
import { KeywordOptimizationGridOption } from '@classes/options/grid/keyword/keywordOptimization';
import { fetchDescriptionAddDelButton, fetchDescriptionAddDelHeader } from '@reducers/keyword/thunk/optimizationThunk';

const AnalysisBox = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { analysisBoxList, appList } = useSelector(({ keywordOptimization }: RootState) => keywordOptimization);

  // gridState
  const [gridChartData, setGridChartData] = useState(null);

  const gridOption = new KeywordOptimizationGridOption();

  // useEffect for setGridData
  useEffect(() => {
    if (analysisBoxList) {
      console.log('appList777: ', appList);
      setGridChartData(
        gridOption.descriptionAnalysisBox(analysisBoxList, appList, gridButtonHandler, gridHeaderHandler)
      );
    } else {
      setGridChartData(null);
    }
  }, [analysisBoxList, appList]);

  // 그리드차트 keyword Add/Del 버튼
  const gridButtonHandler = useCallback(
    ({ keywordId, keyword, currentTracked }) => {
      dispatch(
        fetchDescriptionAddDelButton({
          userId: 'SS',
          tabType: 'description',
          reqType: currentTracked === true ? 'del' : 'add',
          boxType: 'analysisBox',
          keyword: keyword,
          keywordId: keywordId,
        })
      );
    },
    [dispatch, fetchDescriptionAddDelButton]
  );

  // 그리드차트 헤더 Add/Del 버튼
  const gridHeaderHandler = useCallback(
    ({ appId, appTitle, currentTracked }) => {
      dispatch(
        fetchDescriptionAddDelHeader({
          userId: 'SS',
          tabType: 'description',
          reqType: currentTracked === true ? 'del' : 'add',
          boxType: 'analysisBox',
          appId: appId,
          appTitle: appTitle,
        })
      );
    },
    [dispatch, fetchDescriptionAddDelHeader]
  );

  return (
    <div className="optsub-wrap">
      <h3 className="optsub-tit">Description Keywords Analysis</h3>
      <div className="kanalysis-container">
        <h4 className="kanalysis-tit">Character Analysis & Keyword Density</h4>
        <div className="table-api-wrap">
          <div className="table-api table-analysis">
            {gridChartData ? <GridAtom {...gridChartData} height="500px" /> : <DataTable data={[]} columns={[]} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalysisBox;
